import React, { useContext, useEffect, useState, useMemo } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { DesignContext } from '../../../contexts/DesignContext'
import ReactPlayer from 'react-player'
import Label from './Label'

import objectPath from 'object-path'

const CustomVideo = (props) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, setFormData, elementAction } = designContext
  const formData = jsonForm?.formData || {}
  let { uischema, config } = props

  const {
    isDynamic = false,
    dynamicName = '',
    dynamicIndex = 0,
    dynamicData = {},
    onUpdateFormData = () => {},
    isArray,
    arrayName,
  } = config

  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key

  const componentKey = useMemo(() => {
    if (uischema.action.name === 'field' && uischema.action.component) {
      return uischema.action.component.key
    }
    return ''
  }, [])

  let data = objectPath.get(formData, uischema.key)
  let files = objectPath.get(formData, componentKey)
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = objectPath.get(elementAction, ['isEnable', uischema.key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  const [video, setVideo] = useState('')
  const [supportedFile, setSupportedFile] = useState(0)
  const [fileName, setFileName] = useState('')

  const supportedFileHandler = (event) => {
    setSupportedFile(!!event.target.value)
  }

  const onChangeVideo = (e) => {
    e.preventDefault()
    let files = []
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    setFileName(files[0].name)
    let url = URL.createObjectURL(files[0])
    setVideo(url)
    let newFormData = jsonForm.formData
    newFormData[uischema.key] = files
    setFormData(newFormData)
  }

  useEffect(() => {
    if (data) {
      let files = data
      if (files && files[0] && files[0].preview) {
        let url = URL.createObjectURL(files[0])
        setVideo(url)
      } else if (files && files && files.preview) {
        let url = URL.createObjectURL(files)
        setVideo(url)
      } else {
        setVideo('')
      }
    } else {
      if (!uischema.action) return setVideo('')
      if (uischema.action.name === 'field') {
        if (!componentKey) return setVideo('')
        if (files && files[0] && files[0].name) {
          let url = URL.createObjectURL(files[0])
          setVideo(url)
        } else {
          setVideo('')
        }
      } else if (uischema.action.name === 'url') {
        setVideo(uischema.action.src)
      } else if (uischema.action.name === 'video') {
        setVideo('')
      }
    }
  }, [data])

  return (
    <Form.Group className="mb-0" controlId={uischema.controlId}>
      <Row className="w-100 mx-0">
        <Label {...props} uischema={uischema} />
        {uischema.action && uischema.action.name === 'browse' && (
          <Col className="mt-2" sm="auto">
            <div className="custom-file">
              <Form.Control
                type="file"
                className="custom-file-input"
                id={`${fieldKey}-browse`}
                required
                isInvalid={!supportedFile}
                isValid={supportedFile}
                onChange={(event) => {
                  onChangeVideo(event)
                  supportedFileHandler(event)
                }}
                isReadOnly={isReadOnly}
              />
              <Form.Label className="custom-file-label" htmlFor="browseVideo">
                {fileName ? fileName : 'เลือกไฟล์'}
              </Form.Label>
            </div>
          </Col>
        )}
        <Col
          sm={uischema.elementWidth}
          className="mt-2 d-flex justify-content-center"
        >
          {video ? (
            <ReactPlayer
              id={`${fieldKey}-player`}
              style={{
                width: uischema.width,
                height: uischema.height,
              }}
              url={video}
              controls={true}
              playsinline={true}
            />
          ) : (
            <div
              className="bg-light"
              style={{
                width: uischema.width,
                height: uischema.height,
                display: 'flex',
              }}
            ></div>
          )}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CustomVideo
